<sw-page class="dvsn-form-builder dvsn-form-builder-form-detail">
    <template #smart-bar-actions>
        <mt-button
            :disabled="isLoading"
            variant="secondary"
            size="default"
            @click="$router.push({ name: 'dvsn.form.builder.form.list' })"
        >
            {{ $t('dvsn-form-builder-form.detail.actions.cancel-button') }}
        </mt-button>

        <sw-button-process
            :isLoading="isLoading"
            :process-success="isSaveSuccessful"
            variant="primary"
            @update:process-success="saveFinish"
            @click="onClickSave"
        >
            {{ $t('dvsn-form-builder-form.detail.actions.save-button') }}
        </sw-button-process>
    </template>

    {% block dvsn_form_builder_form_detail_language_select %}
        <template #language-switch>
            <sw-language-switch
                :save-changes-function="saveOnLanguageChange"
                :abort-change-function="abortOnLanguageChange"
                @on-change="onChangeLanguage"
            />
        </template>
    {% endblock %}

    <template #side-content>
        <dvsn-form-builder-side-menu
            active="form"
            :isLoading="isLoading"
        ></dvsn-form-builder-side-menu>
    </template>

    <template #content>
        <sw-card-view>
            <mt-tabs
                :items="tabs"
                :default-item="activeTab"
                @new-item-active="activeTab = $event"
            />

            <div v-if="activeTab ==='base'">
                <mt-card
                    :isLoading="isLoading"
                    :title="$t('dvsn-form-builder-form.detail.card-base.title')"
                    class="card-base"
                >
                    <sw-container
                        columns="2fr 1fr"
                        style="column-gap: 30px;"
                    >
                        <mt-text-field
                            v-if="form"
                            v-model="form.name"
                            validation="required"
                            required
                            :label="$t('dvsn-form-builder-form.detail.card-base.name')"
                            :helpText="$t('dvsn-form-builder-form.detail.card-base.name-help')"
                        />

                        <mt-switch
                            v-if="form"
                            v-model="form.status"
                            bordered
                            :label="$t('dvsn-form-builder-form.detail.card-base.status')"
                            :helpText="$t('dvsn-form-builder-form.detail.card-base.status-help')"
                        />
                    </sw-container>
                </mt-card>

                <mt-card
                    :isLoading="isLoading"
                    :title="$t('dvsn-form-builder-form.detail.card-response.title')"
                    class="card-response"
                >
                    <mt-select
                        hide-clearable-button
                        v-if="form"
                        v-model="form.responseType"
                        type="select"
                        :label="$tc('dvsn-form-builder-form.detail.card-response.response-type-label')"
                        :help-text="$tc('dvsn-form-builder-form.detail.card-response.response-type-help')"
                        :options="responseTypes"
                    />

                    <mt-textarea
                        v-if="form"
                        v-model="form.responseMessage"
                        :label="$tc('dvsn-form-builder-form.detail.card-response.response-message-label')"
                        :help-text="$tc('dvsn-form-builder-form.detail.card-response.response-message-help')"
                        :placeholder="$tc('dvsn-form-builder-form.detail.card-response.response-message-placeholder')"

                    />
                </mt-card>

                <mt-card
                    :isLoading="isLoading"
                    :title="$t('dvsn-form-builder-form.detail.card-email.title')"
                    class="card-email"
                >
                    <sw-container
                        columns="2fr 1fr"
                        style="column-gap: 30px;"
                    >
                        <mt-text-field
                            v-if="form"
                            v-model="form.emailRecipient"
                            :label="$t('dvsn-form-builder-form.detail.card-email.email-recipient')"
                            :helpText="$t('dvsn-form-builder-form.detail.card-email.email-recipient-help')"
                        />

                        <mt-switch
                            v-if="form"
                            v-model="form.emailStatus"
                            bordered
                            :label="$t('dvsn-form-builder-form.detail.card-email.email-status')"
                            :helpText="$t('dvsn-form-builder-form.detail.card-email.email-status-help')"
                        />
                    </sw-container>
                </mt-card>
            </div>

            <div v-if="activeTab ==='elements'">
                {% block dvsn_form_builder_form_detail_elements %}
                    <mt-card
                        :isLoading="isLoading"
                        :title="$t('dvsn-form-builder-form.detail.card-elements.title')"
                        class="card-elements"
                    >
                        <mt-banner
                            v-if="form && elements.length == 0"
                            class="dvsn-form-builder-form-elements-alert"
                            variant="info"
                        >
                            {{ $t('dvsn-form-builder-form.detail.card-elements.alert') }}
                        </mt-banner>

                        <sw-data-grid
                            v-if="form && elements.length > 0"
                            :dataSource="elements"
                            :columns="elementsColumns"
                            :fullPage="false"
                            :showSettings="false"
                            :showSelection="false"
                            :showActions="true"
                            :isLoading="isLoading"
                            :allowColumnEdit="false"
                            :allowInlineEdit="false"
                            :compactMode="true"
                            :isRecordEditable="true"
                        >
                            <template #column-position="{ item }">
                                <sw-data-grid-column-position
                                    field="position"
                                    v-model:value="elements"
                                    :showValue="true"
                                    :item="item"
                                />
                            </template>

                            <template #column-name="{ item }">
                                <span v-if="item.type === 'title'" class="prefix-type-title"></span>
                                <span v-else class="prefix-type-default">&#124;</span>

                                <mt-icon
                                    v-if="item.type === 'title'"
                                    name="regular-folder-open"
                                    size="12px"
                                    style="margin-right: 12px;"
                                />

                                <mt-icon
                                    v-else
                                    name="regular-circle-xxs"
                                    size="8px"
                                    style="margin-right: 12px;"
                                />

                                <a @click="onEditElement(item)">
                                    <span v-if="item.type === 'title'" class="item-type-title">{{ item.name }}</span>
                                    <span v-else class="item-type-default">{{ item.name }}</span>
                                </a>
                            </template>

                            <template #column-type="{ item }">
                                {{ getType(item.type) }}
                            </template>

                            <template #actions="{ item }">
                                <sw-context-menu-item
                                    @click="onEditElement(item)"
                                >
                                    {{ $t('dvsn-form-builder-form.detail.card-elements.actions.edit') }}
                                </sw-context-menu-item>

                                <sw-context-menu-item
                                    @click="onDeleteElement(item)"
                                    variant="danger"
                                >
                                    {{ $t('global.default.delete') }}
                                </sw-context-menu-item>
                            </template>
                        </sw-data-grid>

                        <div class="button-container">
                            <mt-button
                                v-if="form"
                                @click="onCreateElement"
                                variant="primary-ghost"
                                size="default"
                            >
                                {{ $t('dvsn-form-builder-form.detail.card-elements.button') }}
                            </mt-button>
                        </div>
                    </mt-card>

                    <dvsn-form-builder-form-detail-element
                        v-if="modalElement !== null"
                        :element="modalElement"
                        @save="onModalElementSave"
                        @cancel="onModalElementCancel"
                    />
                {% endblock %}
            </div>
        </sw-card-view>
    </template>
</sw-page>